import { render, staticRenderFns } from "./PressKitPhotos.vue?vue&type=template&id=1daab86f"
import script from "./PressKitPhotos.vue?vue&type=script&lang=js"
export * from "./PressKitPhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports